/* FP 25/09/2026 : recherche sur mesure.
   - un clic sur une "recherche populaire" remplit le champ et lance la recherche dans la fenetre (pas de rechargement) ;
   - placeholder plus parlant sur les versions anglaises. */
(function () {
  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest ? e.target.closest('[data-fp-q]') : null;
    if (!chip) return;
    var comp = chip.closest('predictive-search-component');
    var input = comp && comp.querySelector('input[type="search"]');
    if (!input) return;
    e.preventDefault();
    e.stopPropagation();
    input.value = chip.getAttribute('data-fp-q');
    input.focus();
    input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: input.value }));
  }, true);

  function placeholder() {
    try {
      var loc = (window.Shopify && Shopify.locale) || document.documentElement.lang || '';
      if (!/^en/i.test(loc)) return;
      document.querySelectorAll('predictive-search-component input[type="search"]').forEach(function (i) {
        i.placeholder = 'Search French presses, grinders, kettles…';
      });
    } catch (err) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeholder); else placeholder();
})();
